export type TechProgressProps = {
    name: string,
    icon: string,
    progressPercent: number
}

const TechProgress= (props:TechProgressProps) =>{
    return(
        <div className={"flex w-40 items-center gap-3 rounded-xl border border-borderLight dark:border-borderDark " +
            "bg-surfaceLight dark:bg-surfaceDark px-3 py-2.5 shadow-sm"}>
            <img alt={props.name} className={"h-9 w-9 shrink-0 object-contain"} src={props.icon}/>
            <div className={"min-w-0 flex-1"}>
                <p className={"truncate text-sm font-semibold"}>{props.name}</p>
                <div className={"mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-borderLight dark:bg-borderDark"}>
                    <div style={{width: props.progressPercent+"%"}} className={"h-full rounded-full bg-accent"}/>
                </div>
            </div>
        </div>
    )
}

export default TechProgress
